"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgMedalFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M12 16a7 7 0 100-14 7 7 0 000 14zm.662-10.074c-.104-.284-.324-.426-.66-.426s-.565.141-.684.423l-.489 1.566H9.122c-.338.023-.54.177-.603.46-.065.285.042.549.317.792l1.263.97-.543 1.9c-.08.294-.01.538.211.731.222.194.51.209.866.047l1.369-.953 1.332.933c.309.18.593.172.85-.027.259-.198.334-.45.226-.754l-.546-1.878 1.303-.97c.28-.244.384-.508.311-.79-.072-.283-.279-.437-.618-.461H13.14l-.479-1.563z' }),
    react_1.default.createElement("path", { d: 'M8 16.502v4.892c0 .917 1.13 1.35 1.744.669L12 19.555l2.257 2.508c.613.681 1.743.248 1.743-.669v-4.892a8.462 8.462 0 01-4 .998 8.462 8.462 0 01-4-.998z' }))); };
exports.default = SvgMedalFilled;
//# sourceMappingURL=MedalFilled.js.map